export const DIMENSIONS = {
    XL: 1200,
    LG: 992,
    MD: 768,
    SM: 576,    
}